import type { ComponentType } from "react";
import { AddonId, SettingsItemId } from "../../data/addons";
// import { AudioDocConfigCard } from "./AudioDocConfigCard"; // TODO(MED-7032): AudioDoc hidden for now — uncomment to re-enable.
// import { BookmarksConfigCard } from "./BookmarksConfigCard"; // TODO(MED-6966): Bookmarks, commented out for v1
import { ChatbotConfigCard } from "./ChatbotConfigCard";
// import { FaqsConfigCard } from "./FaqsConfigCard"; // TODO(MED-6966): faqs, commented out for v1
// import { HeyGeniusConfigCard } from "./HeyGeniusConfigCard"; // TODO(MED-6966): HeyGenius, commented out for v1, not wired on the BE yet — uncomment once it is.
import { QuickRecallConfigCard } from "./quick-recall/QuickRecallConfigCard";
import { GeneralSettingsConfigCard } from "./general-settings";
import { KeyPointsConfigCard } from "./key-points/KeyPointsConfigCard";
// import { NotesConfigCard } from "./NotesConfigCard"; // TODO(MED-6966): notes, commented out for v1
import { PodcastConfigCard } from "./PodcastConfigCard";
// import { TriviaConfigCard } from "./TriviaConfigCard"; // TODO(MED-6966): Trivia, commented out for v1
import { DocumentsConfigCard } from "./DocumentsConfigCard";
import { VideoConfigCard } from "./VideoConfigCard";
import { QuizConfigCard } from "./quiz/QuizConfigCard";
import { StandoutsConfigCard } from "./StandoutsConfigCard";

/** A left-rail item (settings entry or add-on) that can own a config card. */
export type ConfigItemId = SettingsItemId | AddonId;

/**
 * Maps a left-rail item to its right-panel configuration card. Items without an
 * entry fall back to the "coming soon" placeholder — register a card here as
 * each one lands (quiz, general settings, …) instead of branching per add-on in
 * the panel.
 */
export const CONFIG_CARDS: Partial<Record<ConfigItemId, ComponentType>> = {
  documents: DocumentsConfigCard,
  general: GeneralSettingsConfigCard,
  Video: VideoConfigCard,
  Podcast: PodcastConfigCard,
  // AudioDoc: AudioDocConfigCard, // TODO(MED-7032): AudioDoc hidden for now — uncomment to re-enable.
  Flashcards: QuickRecallConfigCard,
  // Bookmarks: BookmarksConfigCard, // TODO(MED-6966): commented out for v1, not wired on the BE yet — uncomment once it is.
  // notes: NotesConfigCard, // TODO(MED-6966): commented out for v1, not wired on the BE yet — uncomment once it is.
  // Trivia: TriviaConfigCard, // TODO(MED-6966): commented out for v1, not wired on the BE yet — uncomment once it is.
  // faqs: FaqsConfigCard, // TODO(MED-6966): commented out for v1, not wired on the BE yet — uncomment once it is.
  // heygenius: HeyGeniusConfigCard, // TODO(MED-6966): HeyGenius, commented out for v1, not wired on the BE yet — uncomment once it is.
  Quiz: QuizConfigCard,
  Chatbot: ChatbotConfigCard,
  // "Key points" is the frontend name for the backend `Summary` add-on.
  Summary: KeyPointsConfigCard,
  Standouts: StandoutsConfigCard,
};
